import { lazy } from 'react';
import { Route } from 'react-router-dom';

/**
 * Public auth routes — lazy-loaded (FE-ADR-001: routes live with their
 * feature; App.tsx only composes). Returned as a fragment of <Route> elements;
 * React Router flattens fragments inside <Routes>.
 */
const LoginPage = lazy(() => import('./pages/LoginPage').then(m => ({ default: m.LoginPage })));
const RegisterPage = lazy(() =>
  import('./pages/RegisterPage').then(m => ({ default: m.RegisterPage }))
);
const ForgotPasswordPage = lazy(() =>
  import('./pages/ForgotPasswordPage').then(m => ({ default: m.ForgotPasswordPage }))
);
const ResetPasswordPage = lazy(() =>
  import('./pages/ResetPasswordPage').then(m => ({ default: m.ResetPasswordPage }))
);

export const authRoutes = (
  <>
    <Route path="/login" element={<LoginPage />} />
    <Route path="/register" element={<RegisterPage />} />
    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
    <Route path="/reset-password" element={<ResetPasswordPage />} />
  </>
);
